import * as React from 'react'

import { ChevronDown, ChevronRight } from 'lucide-react'

interface IExpandToggleProps {
  expanded: boolean
}

export default function ExpandToggle({
  expanded,
}: IExpandToggleProps): React.ReactElement {
  const Icon = expanded ? ChevronDown : ChevronRight
  return <Icon aria-hidden="true" />
}
